import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-482a0566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "nav-bar-title nav-bar-loading-title"
}
const _hoisted_3 = {
  key: 1,
  class: "nav-bar-title"
}
const _hoisted_4 = { class: "nav-bar-name" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 加载中... ")
const _hoisted_6 = { class: "top-action-panel" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "scroll-to-bottom-icon-stack",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "van-icon van-icon-arrow-down" }),
  /*#__PURE__*/_createElementVNode("i", { class: "van-icon van-icon-arrow-down" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "bottom-container" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("发起对话")
const _hoisted_11 = { class: "block" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发起对话中...", -1))
const _hoisted_13 = { style: {"padding":"20px","display":"flex","margin-left":"60px"} }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("拉黑并关闭对话")
const _hoisted_15 = { style: {"padding":"0 20px 20px 20px","display":"flex","margin-left":"60px"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("举报广告骚扰、其他违规")
const _hoisted_17 = { style: {"padding":"0 20px 20px 20px","display":"flex","margin-left":"60px"} }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("举报黄赌毒、政治敏感")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_history_detail_page_subtitle = _resolveComponent("history-detail-page-subtitle")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_yunque_message = _resolveComponent("yunque-message")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_tag_edit = _resolveComponent("tag-edit")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_history_source_dialog = _resolveComponent("history-source-dialog")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _directive_chat_scroll = _resolveDirective("chat-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, {
        onClickLeft: _ctx.goBack,
        "left-text": "返回",
        "left-arrow": ""
      }, {
        title: _withCtx(() => [
          (_ctx.detailLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 加载中... "))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentHistoryDetail?.feName || _ctx.currentHistoryDetail?.name), 1),
                _createVNode(_component_history_detail_page_subtitle, { detail: _ctx.currentHistoryDetail }, null, 8, ["detail"])
              ]))
        ]),
        _: 1
      }, 8, ["onClickLeft"]),
      (_ctx.detailLoading)
        ? (_openBlock(), _createBlock(_component_van_loading, {
            key: 0,
            class: "detail-page-loading",
            vertical: ""
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }))
        : (_ctx.currentHistoryDetail)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "top-action",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSourceDialog = true))
                }, "访客来源"),
                _createElementVNode("div", {
                  class: "top-action",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editLead && _ctx.editLead(...args)))
                }, "编辑客资"),
                _createElementVNode("div", {
                  class: "top-action",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showEditTag = true))
                }, "编辑标签"),
                _createElementVNode("div", {
                  class: "top-action",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.report && _ctx.report(...args)))
                }, "举报拉黑")
              ]),
              _withDirectives(_createElementVNode("div", {
                ref: "messageList",
                class: "message-list",
                onScrollPassive: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onMessageListScroll && _ctx.onMessageListScroll(...args)))
              }, [
                (_ctx.messageListTopSpacerHeight)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "message-list-top-spacer",
                      style: _normalizeStyle({ height: _ctx.messageListTopSpacerHeight + 'px' })
                    }, null, 4))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (message) => {
                  return (_openBlock(), _createBlock(_component_yunque_message, {
                    message: message,
                    key: message.microtime,
                    "data-message-microtime": _ctx.messageDomMicrotime(message),
                    class: _normalizeClass({ 'message-target-highlight': _ctx.isTargetMessage(message) }),
                    onOnRecall: _ctx.recallMessage
                  }, null, 8, ["message", "data-message-microtime", "class", "onOnRecall"]))
                }), 128))
              ], 544), [
                [_directive_chat_scroll, { always: false, smooth: true }]
              ]),
              _withDirectives(_createElementVNode("button", {
                class: "scroll-to-bottom-button",
                type: "button",
                "aria-label": "滚动到底部",
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleScrollToBottomClick && _ctx.handleScrollToBottomClick(...args)), ["stop"]))
              }, _hoisted_8, 512), [
                [_vShow, _ctx.showScrollToBottomButton]
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_van_button, {
                  id: "start-btn",
                  onClick: _ctx.startCon,
                  block: "",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ], 64))
          : _createCommentVNode("", true)
    ]),
    (_ctx.showEditTag && _ctx.currentHistoryDetail?.uid)
      ? (_openBlock(), _createBlock(_component_tag_edit, {
          key: 0,
          uid: _ctx.currentHistoryDetail.uid,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showEditTag = false))
        }, null, 8, ["uid"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_overlay, { show: _ctx.showLoadingStartingCon }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_van_loading, {
              type: "spinner",
              color: "#1989fa"
            }),
            _hoisted_12
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_dialog, {
      show: _ctx.showSourceDialog,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showSourceDialog) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.currentHistoryDetail)
          ? (_openBlock(), _createBlock(_component_history_source_dialog, {
              key: 0,
              currentHistoryVisitor: _ctx.currentHistoryDetail
            }, null, 8, ["currentHistoryVisitor"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_dialog, {
      show: _ctx.showReportDialog,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showReportDialog) = $event)),
      title: "确定举报该用户吗",
      "show-cancel-button": "",
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      onConfirm: _ctx.doReport,
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showReportDialog = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_van_checkbox, {
            modelValue: _ctx.isReportAndBlock,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isReportAndBlock) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_van_checkbox, {
            modelValue: _ctx.isReportPlaceholder,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isReportPlaceholder) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_van_checkbox, {
            modelValue: _ctx.isReportLegal,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isReportLegal) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["show", "onConfirm"])
  ], 64))
}